import { gql } from '@apollo/client';

export const DELETE_COMMUNITY_GROUP_ACTION = gql`
  mutation DeleteCommunityGroupAction($communityGroupId: ID!, $actionName: String!) {
    deleteCommunityGroupAction(communityGroupId: $communityGroupId, actionName: $actionName)
  }
`;
